import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Handle OAuth callback
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (error) {
      // Handle error - maybe redirect to login or show error message
      navigate('/', { replace: true });
      return;
    }

    if (code) {
      // For now, redirect to landing page
      navigate('/', { replace: true });
    } else {
      // No code or error, redirect to landing
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="auth-callback">
      <h2>Processing authentication...</h2>
      <p>Please wait while we complete your login.</p>
    </div>
  );
};

export default AuthCallback; 